/*
 * Product pages.
 */

import { randomNumber, randomString } from "../test/mocks/utils";

export const SEGMENT_CMC = "Commercial aviation";

export const SEGMENT_BZA = "Business aviation";
export const URL_BZA_AIRCRAFT_DATA = "/products/business-aircraft-data";
export const URL_BZA_OPERATOR_CONTACT_DATA =
	"/products/business-operator-contact-data";
export const URL_BZA_OPERATOR_AIRPORT_DATA =
	"/products/business-operator-airport-data";
export const URL_CMC_AIRCRAFT_DATA = "/products/commercial-aircraft-data";
export const URL_CMC_OPERATOR_AIRPORT_DATA =
	"/products/commercial-operator-airport-data";
export const URL_CMC_OPERATOR_CONTACT_DATA =
	"/products/commercial-operator-contact-data";

export const MODULE_DETAILS = {
	code: randomString(),
	id: randomNumber(),
	name: randomString(),
	price: randomNumber(),
};
